import { Link } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";

// Main component
const IconsLayout4 = ({ industries }) => {
	const [visibleCount, setVisibleCount] = useState(8); // Default to show 8 on large screens
	const [showAll, setShowAll] = useState(false); // Tracks if "View All" was clicked

	// Dynamically update visible items based on screen size.
	const updateVisibleCount = () => {
		if (window.innerWidth < 768) {
			setVisibleCount(3); // Show 3 on mobile
		} else if (window.innerWidth < 992) {
			setVisibleCount(6); // Show 6 on medium screens
		} else {
			setVisibleCount(8); // Show 8 on desktop
		}
	};

	useEffect(() => {
		updateVisibleCount();
		window.addEventListener("resize", updateVisibleCount);
		return () => window.removeEventListener("resize", updateVisibleCount);
	}, []);

	const handleViewAll = () => {
		setShowAll(true);
	};

	const itemsToShow = showAll ? industries : industries.slice(0, visibleCount);

	// Inline styles for the icon and default title.
	const iconStyles = {
		width: "40px",
		height: "40px",
	};

	const titleStyles = {
		color: "#00304B",
	};

	// Helper to convert hex colors to rgba with a specified alpha.
	const convertHexToRGBA = (hex, alpha) => {
		hex = hex.replace("#", "");
		const r = parseInt(hex.substring(0, 2), 16);
		const g = parseInt(hex.substring(2, 4), 16);
		const b = parseInt(hex.substring(4, 6), 16);
		return `rgba(${r}, ${g}, ${b}, ${alpha})`;
	};

	// Card component for each industry.
	const IndustryCard = ({ item }) => {
		const [hovered, setHovered] = useState(false);
		const icon = item.industryFields.icon;
		const hoverColor = item.industryFields.colour; // e.g. "#FF0000"
		// Create a low-opacity background color (alpha 0.1).
		const backgroundColorHover = convertHexToRGBA(hoverColor, 0.1);

		return (
			<Link
				to={`/industries/${item.slug}`}
				style={{
					textDecoration: "none",
					color: "inherit",
					display: "block",
					height: "100%",
				}}
			>
				<div
					onMouseEnter={() => setHovered(true)}
					onMouseLeave={() => setHovered(false)}
					style={{
						padding: "1rem",
						transition: "background-color 0.3s, color 0.3s",
						backgroundColor: hovered ? backgroundColorHover : "transparent",
						display: "flex",
						flexDirection: "column",
						height: "100%",
					}}
				>
					{/* Main Content */}
					<div style={{ flex: "1" }}>
						<img
							className="mb-3"
							src={icon.sourceUrl}
							alt={icon.altText || item.title}
							style={iconStyles}
						/>

						<h3
							className="fs-5"
							style={{
								...titleStyles,
								transition: "color 0.3s",
								color: hovered ? hoverColor : titleStyles.color,
							}}
						>
							{item.title}
						</h3>

						<p>{item.industryFields.description}</p>
					</div>

					{/* "Learn More" section pinned to the bottom */}
					<div style={{ marginTop: "auto" }}>
						<div className="d-flex align-items-center">
							<span className="outfit-regular">Learn More</span>
							<span>
								<MdKeyboardArrowRight className="fs-5 ms-1 text-primary" />
							</span>
						</div>
					</div>
				</div>
			</Link>
		);
	};

	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row className="g-5">
					{itemsToShow.map((item) => (
						<Col md={6} xs={12} lg={3} key={item.id}>
							<IndustryCard item={item} />
						</Col>
					))}
				</Row>

				{/* "View All" Button */}
				{!showAll && visibleCount < industries.length && (
					<Row className="mt-5 mt-lg-6">
						<Col className="text-center">
							<Button
								onClick={handleViewAll}
								variant="outline-primary"
								style={{ borderRadius: "0px" }}
								className="w-100 w-md-auto py-2 px-4"
							>
								View All
							</Button>
						</Col>
					</Row>
				)}
			</Container>
		</section>
	);
};

export default IconsLayout4;
